<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    show: false,
    errorClass: 'bg-red-100 border-red-400 text-red-700',
    successClass: 'bg-green-100 border-green-400 text-green-700',
  }),
  computed: {
    ...mapState('app', ['alert']),
  },
  watch: {
    alert() {
      this.show = true
      setTimeout(() => {
        this.show = false
      }, 6000)
    },
  },
}
</script>

<template>
  <transition name="fade">
    <div
      v-if="show"
      class="border px-4 py-3 mb-6 rounded-sm relative"
      :class="[alert.type === 'error' ? errorClass : successClass]"
      role="alert"
    >
      <span class="block sm:inline">{{ alert.message }}</span>
      <span
        class="absolute top-0 bottom-0 right-0 px-4 py-3 cursor-pointer"
        @click="show = false"
      >
        <i class="fas fa-times"></i>
      </span>
    </div>
  </transition>
</template>
